/* Declerations */

// Plugins
import * as d3 from "d3"
import _ from 'lodash'
import axios from 'axios';

/* Mixins */
import { cacheMixins } from "./cacheMixins"


export const achievementmixins = {
    mixins : [cacheMixins],
    data() {
        return {
            achievements       : [],
            achievementgroup  : [],
            colors            : ['#21bcaa', '#fcc14c', '#e85941'],
            userachievementlvl: null
        }
    },
    computed : {
        /* Get Logged in user */
        user() {
            return this.$store.state.user
        }
    },
    methods : {
        /**
         * Delete achievement level
         * @param {Number} id achievement level id
         * @param {Function} callback
         */
        async deleteAchievementLevel({id = null, callback = () => {}} = {}) {
            const url = `/parent/achievementlevel/${id}`
            await axios.delete(url).catch(err => err);

            callback()
        },  
        /**
         * Create new achievement level
         * @param {Object} params
         * @param {Function} callback
         */
        async createAchievementLevel({params = {}, callback = () => {}} = {}) {
            const url = `/parent/achievementlevel`;
            const res = await axios.post(url, params).catch(err => err);

            if(res?.data) {
                callback(res.data);
            }
        },
        /**
         * Update Achievement Level
         * @param {Object} params
         * @param {Function} callback
         */
        async updateAchievementLevel({params = {}, callback = () => {}} = {}) {
            const url = `/parent/achievementlevel/${params.id}`;

            const res = axios.patch(url, params).catch(err => err);


            if(res) {
                callback(res);
            }
        },
        /**
         * Get Achievemnt Level
         * @param {Number} id achievement level id
         * @param {Function} callback
         */
        async getAchievementLevel({id = null, callback = () => {}} = {}) {
            const url = `/parent/achievementlevel/${id}`;

            const res = await this.cacheFirst({url, method : "GET", callback : (res) => callback(res?.data)});

            if(res?.data) {
                callback(res.data);
            }
        },
        /** Get Achievemnt Level list 
         * @param {Function} callback
         */
        async getAchievementLevels ({callback  = () => {}} = {}) {
            const url = `/parent/achievementlevel`;
            const res = await this.cacheFirst({url, method : "GET", callback : (res) => callback(res?.data)});

            if(res?.data) {
                callback(res.data)
            }
        },
        /**
         * Get achievment list
         */
         getachievment : _.debounce(async function ({callback = () => {}} = {}) {
            const url = `/parent/achievementlevel`
            // const res = await axios.get(url).catch(err => console.log(err))

            const res = await this.cacheFirst({url, method : "GET"});

            if(res && res) {
                const achievements = res.data.sort((a, b) => a.level - b.level)
                this.achievements = achievements

                // Group achievements
                // this.groupachivement()
                /* Get user current achievement level */
                if(this.user && this.user.achievement_level_id) {
                    const currentachievement = this.achievements.find(ac => ac.id == this.user.achievement_level_id)
                    const [defaultachievement] = this.achievements
                    this.userachievementlvl = currentachievement ? currentachievement : defaultachievement
                } else {
                    // no achievement get the first level
                    [this.userachievementlvl] = this.achievements

                }

                callback(achievements)

            }
        }, 300),
         /**
         * Initialize chart
         */
          initchart (ac, chartcontainer) {

            
            /* Prevent from initiating if no achievement */
            console.log(this.user, 'datasaccc', ac)
            
            if(!ac) {
                return ;
            }
            
            /**
             * Compose data for the chart
             */
            let datas = []

            if(ac) {
                /* Get weak leg */
                let weakleg = this.user && this.user.synergy_detail  ?  parseFloat(this.user.synergy_detail.synergy_left_leg_cv) +  parseFloat(this.user.synergy_detail.synergy_right_leg_cv)  : 0

                /* Get previous ac goal and add to current cv */
                /* Get previous goal level cv point and add to current cv */
                const prevGoal = this.user && this.user.achievement_level ? this.achievements.find(ac => ac.level == (this.user.achievement_level.level - 1)) : null

                if(prevGoal) {
                    weakleg = (weakleg + parseFloat(prevGoal.cv_weak_leg_goal.replace(',', '')))
                }

                /* Get sponsored number */
                const sponsored = this.user && this.user.synergy_detail && this.user.synergy_detail.synergy_personally_sponsored_count ? this.user.synergy_detail.synergy_personally_sponsored_count : 0

                /* Autoship  */
                const autohShip = this.user.synergy_detail ? parseFloat(this.user.synergy_detail.synergy_left_leg_cv) + parseFloat(this.user.synergy_detail.synergy_right_leg_cv)  : 0 

                /* Check if this achievement is already completed */
                const iscompleted = this.userachievementlvl && this.userachievementlvl.level > ac.level ? true : false
                const isCurrentLvl = this.userachievementlvl && this.userachievementlvl.level == ac.level ? true : false
                
                console.log(ac.level, iscompleted, 'acccc', ac, autohShip, parseFloat(ac.cv_autoship), weakleg, sponsored)
                /* Get qualifications */
                if(ac.cv_autoship_goal) {
                    // const name = titleCase(ac.cv_autoship_goal)

                    const qualification =  [{
                        label: 'Autoship',
                        color: this.colors[0],
                        type : 'current', 
                        value:  iscompleted ? 100 : isCurrentLvl ? 100 :  0,
                    },
                    {
                        label: 'Autoship',
                        color: '#f1f1f2',
                        type : 'max',
                        value: iscompleted ? 0 : isCurrentLvl ? 0 : 100,
                    }]
                    datas = [...datas, {data : qualification}]
                }

                if(ac.cv_weak_leg_goal) {
                    // const name = titleCase(ac.cv_weak_leg_goal)

                    const qualification =  [{
                        label: 'Weak Leg',
                        color: this.colors[1],
                        type : 'current',
                        value: iscompleted ? 100 : isCurrentLvl ? weakleg : 0,
                    },
                    {
                        label: 'Weak Leg',
                        color: '#f1f1f2',
                        type : 'max',
                        value: iscompleted ? 0 : isCurrentLvl ?  weakleg >= parseFloat(ac.cv_weak_leg) ? 0 : parseFloat(ac.cv_weak_leg) : 100,
                    }]

                    datas = [...datas, {data : qualification}]
                }

                if(ac.sponsorship) {
                    // const name = titleCase(ac.other_goal)

                    const qualification =  [{
                        label: 'Sponsor',
                        color: this.colors[2],
                        type : 'current',
                        value: iscompleted ? 100 : isCurrentLvl ? sponsored > parseFloat(ac.sponsorship) ? parseFloat(ac.sponsorship) : sponsored : 0,
                    },
                    {
                        label: 'Sponsor',
                        color: '#f1f1f2',
                        type : 'max',
                        value: iscompleted ? 0 : isCurrentLvl ?  sponsored > parseFloat(ac.sponsorship) ? 0 : parseFloat(ac.sponsorship) : 100,
                    }]
                    datas = [...datas, {data : qualification}]
                }
                
                    
                // Check if level 0 then add default data
                if(ac.level == 0) {
                    const finishedSession = this.trainingsessions.filter(t => t.id < this.trainingprogress.trainingsession_id)

                    let donesesions      = finishedSession.length
                    let remainingsession = this.trainingsessions.length - finishedSession.length
                    
                    // /* Check if same session id with first session id then reset all*/
                    // const currrentsession = this.trainingprogress  ? this.trainingprogress.trainingsession_id : null
                    // const [firstsession]  = this.trainingsessions

                    console.log(isCurrentLvl, 'achivement level 0', donesesions, remainingsession)
                    
                    /* Check if training session is completed then complete the achievements */
                    if(this.trainingprogress.is_session_complete) {
                        donesesions      = 100
                        remainingsession = 0
                    }

                    datas = [
                        {
                            data : [
                                
                                {
                                    label: 'Training',
                                    color: this.colors[0],
                                    type : 'current',
                                    value: iscompleted ? 100 : isCurrentLvl ?  donesesions : 0,
                                },
                                {
                                    label: 'Training',
                                    color: '#f1f1f2',
                                    type : 'max',
                                    value  : iscompleted ? 0 : isCurrentLvl ?  remainingsession : 100,
                                }
                            ],
                        }
                    ]
                }
                
            }


            
        
                
            //Chart configs
            const container = document.querySelector(chartcontainer);

            console.log(ac.level, 'datas', datas, container, chartcontainer)
            
            /* dont proceed if did not exist */
            if(!container) return;

            const width     = container.clientWidth,
                  height    = container.clientHeight,
                  radius    = Math.min(width, height) / 2;

            console.log('heightheight', height)

            if(d3.select(chartcontainer).select("svg")) d3.select(chartcontainer).select("svg").remove();


            //make an SVG
            const svg = d3.select(chartcontainer).append("svg")
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

            svg.append('foreignObject')
                    .attr("width", width)
                    .attr("height", height)
                    .attr('y', -height / 2)
                    .attr('x', -width / 2)
                    .append('xhtml:div')
                        .attr("class", "level")
                        .attr("text-anchor", "middle")
                        .attr('y', 10)
                        .html(() => {
                            return `<span class="top">${ac.level == 0 ? 'T' : ac.level}</span><span class="bottom">${ac.level == 0  ? 'Training' : ac.description}</span>`; 
                        });

            /**
             * Call function to create chart
             */
         
            initchart()


            /**
             * Chart functions 
             * Generate rings with data provided
             */
            function initchart() {
                let offsetinner = 10;
                let offsetouter = 5;

                datas.forEach((data, index) => {
                    const label = data.data.map(d => d.value).join(' / ')

                    /**
                     * Create pie
                     */
                    const pie = d3.pie()
                        .sort(null).value(function (d) {
                        return d.value;
                    });

                    /** Create arc for the ring */
                    const arc = d3.arc()
                        .innerRadius(radius - offsetinner)
                        .outerRadius(radius - offsetouter);

                    /**
                     * Render all data
                     */
                    const g = svg.selectAll(`.arc${index}`)
                        .data(pie(data.data))
                        .enter().append("g")
                        .attr("class", `arc${index}`);
                    
                    g.append("path")
                        .attr("d", arc)
                        .style("fill", function (d) {
                            return d.data.color;
                        })
                        .on("mouseover", function(){
                            d3.select(this.parentNode).select(".tooltipwrap").style("display", "block");
        
                        }).on("mouseout", function(){
                            d3.select(this.parentNode).select(".tooltipwrap").style("display", "none");
                        });

                    /**
                     * Add tooltip
                     */
                    g.append('foreignObject')
                    .attr("transform", function (d) {
                        return "translate(" + arc.centroid(d) + ")";
                    })
                    .attr('class', 'tooltipwrap')
                    .attr("style", (d) => `display:none; ${d.data.type !== 'current' ? 'visibility : hidden' : ''}`)
                    .append('xhtml:div')
                        .attr("class", (d) => {
                            return `${d.data.label}`
                        })
                        .attr("text-anchor", "middle")
                        .html((d) => {
                            if(d.data.type == 'current') {
                                return label
                            } else {
                                return ''
                            }
                        });


                    /**
                     * Increate offset per loop
                     */

                    offsetinner = offsetinner + 10;
                    offsetouter = offsetouter + 10;
                });

            }

        },
         /**
         * Generate chart 
         */
         generateChart ({
                ac               = {
                    level      : 0,
                    description: 'Training'
                },
                centerLabelWeight = null,
                centerLabelHeight = null,
                width             = 300,
                height            = 300,
                weakleg           = 0,
                cvAutoship        = 0,
                sponsored         = 0,
                offsetinner       = 4,
                offsetouter       = 2,
                offetIncrease     = 4,
                hasCertDesc       = true,
                trainingProgress  = {
                    completedNumber : 0,
                    remainingSession: 100
                }
                }                = {}) {

            
            /* Prevent from initiating if no achievement */
            // let ac = null

            width = height;
            centerLabelWeight = centerLabelWeight || width
            centerLabelHeight = centerLabelHeight ||  height

            const radius = Math.min(width, height) / 2;

            let newOffsetInner = offsetinner
            let newOffsetOuter  = offsetouter
            
            /**
             * Compose data for the chart
             */
            let datas = []

            if(ac) {
                /* Chart data for level 1 and above */
                if(ac.level > 0) {
                    /* Get weak leg */
                    console.log(hasCertDesc, 'acccc', ac, weakleg, cvAutoship, sponsored)

                    /* Check if this achievement is already completed */
                    

                    /* Get qualifications */
                    if(ac.cv_autoship_goal) {
                        // const name = titleCase(ac.cv_autoship_goal)

                        const qualification =  [{
                            label: 'Autoship',
                            color: this.colors[0],
                            type : 'current',
                            value: cvAutoship,
                        },
                        {
                            label: 'Autoship',
                            color: '#f1f1f2',
                            type : 'max',
                            value: cvAutoship > parseFloat(ac.cv_autoship) ? 0: parseFloat(ac.cv_autoship) - cvAutoship,
                        }]
                        datas = [...datas, {data : qualification}]
                    }

                    if(ac.cv_weak_leg_goal) {
                        // const name = titleCase(ac.cv_weak_leg_goal)

                        const qualification =  [{
                            label: 'Weak Leg',
                            color: this.colors[1],
                            type : 'current',
                            value: weakleg,
                        },
                        {
                            label: 'Weak Leg',
                            color: '#f1f1f2',
                            type : 'max',
                            value: parseFloat(ac.cv_weak_leg),
                        }]

                        datas = [...datas, {data : qualification}]
                    }

                    if(ac.sponsorship) {
                        // const name = titleCase(ac.other_goal)

                        const qualification =  [{
                            label: 'Sponsor',
                            color: this.colors[2],
                            type : 'current',
                            value: sponsored,
                        },
                        {
                            label: 'Sponsor',
                            color: '#f1f1f2',
                            type : 'max',
                            value: parseFloat(ac.sponsorship),
                        }]
                        datas = [...datas, {data : qualification}]
                    }
                }

                console.log(weakleg, cvAutoship, sponsored, 'generate ac chart', datas);
                    
                // Check if level 0 then add default data
                /* Chart data for level 0 member */
                if(ac.level == 0) {

                    /* Get completed session number and remaining session number */
                    let donesesions      = trainingProgress.completedNumber
                    let remainingsession = trainingProgress.remainingSession

                    console.log('certification achievement', donesesions, remainingsession)
                    

                    datas = [
                        {
                            data : [
                                
                                {
                                    label: 'Training',
                                    color: this.colors[0],
                                    type : 'current',
                                    value: donesesions,
                                },
                                {
                                    label: 'Training',
                                    color: '#f1f1f2',
                                    type : 'max',
                                    value  : remainingsession,
                                }
                            ],
                        }
                    ]
                }
                
            }


            //make an SVG
            const svg = d3.create('svg')
                .attr('width', width)
                .attr('height', height)
                .style("-webkit-tap-highlight-color", "transparent")
                .style("overflow", "visible")
                .style("shape-rendering", "geometricPrecision")

            const g = svg.append("g")
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

            // g.append('text')
            //     .text(ac.level)
            
            // g.append('text')
            //     .text(() => {
            //         return ac.level == 0  ? 'Certification' :ac.description ? ac.description : ''
            //     })

            // g

            // const centerDivY = -height 
            // const centerDivY = hasCertDesc ? -height / 2  : -height / 2.8

            g.append('foreignObject')
                    .attr("width", centerLabelWeight)
                    .attr("height", centerLabelHeight)
                    .attr('y', -(centerLabelHeight/2))
                    .attr('x', -(centerLabelWeight/2))
                    
                    .append('xhtml:div')
                        // .style('transform', `translate(0, 45%)`)
                        .attr("class", "level")
                        .attr("text-anchor", "middle")
                        .html(() => {
                            
                            if(!hasCertDesc) return  `<span class="top">${ac.level == 0 ? 'T' : ac.level}</span>`; 

                            return `<span class="top">${ac.level == 0 ? 'T' : ac.level}</span> <span class="bottom">${ac.level == 0  ? 'Training' :ac.description ? ac.description : ''}</span>`; 
                        });

            /* Draw chart */
            

            datas.forEach((data, index) => {
                const label = data.data.map(d => d.value).join(' / ')

                console.log('newOffsetInner', newOffsetInner, newOffsetOuter)

                /**
                 * Create pie
                 */
                const pie = d3.pie()
                    .sort(null).value(function (d) {
                    return d.value;
                });

                /** Create arc for the ring */
                const arc = d3.arc()
                    .innerRadius(radius - newOffsetInner)
                    .outerRadius(radius - newOffsetOuter);

                /**
                 * Render all data
                 */
                const gArc = g.selectAll(`.arc${index}`)
                    .data(pie(data.data))
                    .enter().append("g")
                    .attr("class", `arc${index}`);
                
                gArc.append("path")
                    .attr("d", arc)
                    .style("fill", function (d) {
                        return d.data.color;
                    })
                    .on("mouseover", function(){
                        d3.select(this.parentNode).select(".tooltipwrap").style("display", "block");
    
                    }).on("mouseout", function(){
                        d3.select(this.parentNode).select(".tooltipwrap").style("display", "none");
                    });

                /**
                 * Add tooltip
                 */
                gArc.append('foreignObject')
                .attr("transform", function (d) {
                    return "translate(" + arc.centroid(d) + ")";
                })
                .attr('class', 'tooltipwrap')
                .attr("style", (d) => `display:none; ${d.data.type !== 'current' ? 'visibility : hidden' : ''}`)
                .append('xhtml:div')
                    .attr("class", (d) => {
                        return `${d.data.label}`
                    })
                    .attr("text-anchor", "middle")
                    .html((d) => {
                        if(d.data.type == 'current') {
                            return label
                        } else {
                            return ''
                        }
                    });


                /**
                 * Increate offset per loop
                 */

                

               
                newOffsetInner = newOffsetInner + offetIncrease;
                newOffsetOuter = newOffsetOuter + offetIncrease;
            });

            // console.log(svg.node(), 'chart circle data', datas)



            return svg.node()

        }
    }   
}